// wikiBlockRegistry.js — Notion-style block types for Wiki pages.
// Same {block_id, block_type, props} shape as the email-builder registry.

import {
    Type, Heading1, Heading2, List, ListOrdered, CheckSquare, Quote,
    Minus, Code, ChevronRight, Table, Image as ImageIcon, Sparkles, Video,
} from 'lucide-react';

// Block menu (slash menu / "add block") — order matters for the picker.
export const WIKI_BLOCK_MENU = [
    { type: 'text', label: 'Text', icon: Type },
    { type: 'h1', label: 'Heading 1', icon: Heading1 },
    { type: 'h2', label: 'Heading 2', icon: Heading2 },
    { type: 'bullet', label: 'Bulleted list', icon: List },
    { type: 'num', label: 'Numbered list', icon: ListOrdered },
    { type: 'check', label: 'To-do', icon: CheckSquare },
    { type: 'callout', label: 'Callout', icon: Sparkles },
    { type: 'quote', label: 'Quote', icon: Quote },
    { type: 'code', label: 'Code', icon: Code },
    { type: 'toggle', label: 'Toggle', icon: ChevronRight },
    { type: 'table', label: 'Table', icon: Table },
    { type: 'image', label: 'Image', icon: ImageIcon },
    { type: 'embed', label: 'Video embed', icon: Video },
    { type: 'divider', label: 'Divider', icon: Minus },
];

const DEFAULTS = {
    h1: { text: 'Heading' },
    h2: { text: 'Heading' },
    text: { text: '' },
    bullet: { text: '' },
    num: { text: '' },
    check: { text: '', done: false },
    callout: { text: '', tone: 'violet', icon: 'sparkles' },
    quote: { text: '' },
    divider: {},
    code: { text: '' },
    toggle: { text: 'Toggle', body: '' },
    table: { head: ['Column 1', 'Column 2'], rows: [['', '']] },
    image: { url: '', caption: '', alt: '' },
    embed: { url: '', caption: '' },
};

export const CALLOUT_TONES = ['violet', 'indigo', 'amber', 'cyan'];

let _seq = 0;
function newId() {
    _seq += 1;
    return 'blk_' + Date.now().toString(36) + _seq.toString(36);
}

export function createBlock(blockType, initialProps = null) {
    const base = DEFAULTS[blockType] || { text: '' };
    return {
        block_id: newId(),
        block_type: blockType,
        props: { ...JSON.parse(JSON.stringify(base)), ...(initialProps || {}) },
    };
}

// Block-identity key for the version diff (matches the prototype's blockKey).
export function blockKey(b) {
    const p = b.props || {};
    const text = p.text || p.url || p.caption || JSON.stringify(p.rows || p.head || '');
    return `${b.block_type}|${text}`;
}

// Is this a text-bearing block (editable inline)?
export const TEXT_BLOCKS = new Set(['h1', 'h2', 'text', 'bullet', 'num', 'check', 'callout', 'quote', 'toggle', 'code']);
